import { useCallback, useState } from "react";
import Swal from "sweetalert2";
import { AXIOS_UPDATE } from "../../../server/api/crud";
import PersoonlijkeInfo from "./details/PersoonlijkeInfo";
import HulpVraag from "./details/HulpVraag";
import Gezondheidsprofiel from "./details/Gezondheidsprofiel";
import { savePreIntakeForm, updateOpmerking } from "../../../apiCalls/preintake";
import "./preintake-theme.css";

const PreIntakeForm = ({
  formData,
  setFormData,
  setOpen,
  userdetails,
  admin = null,
  onProgressUpdate,
}) => {
  
  const isadmin = admin == null ? false : true;
  const [errors, setErrors] = useState(null);
  const [editeer, setEditeer] = useState(isadmin);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    if (type === "checkbox") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: checked,
      }));
    } else if (type === "select-multiple") {
      const selectedOptions = Array.from(e.target.selectedOptions).map(
        (option) => option.value
      );
      setFormData((prevData) => ({
        ...prevData,
        [name]: selectedOptions,
      }));
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
      }));
    }

    validateField(name, value);
  };

  const validateField = (name, value) => {
    let error = "";
    switch (name) {
      case "age":
        if (!value || isNaN(value) || value <= 0)
          error = "Voer een geldige leeftijd in.";
        break;
      case "weight":
        if (!value || isNaN(value) || value <= 0)
          error = "Voer een geldig gewicht in.";
        break;
      case "height":
        if (!value || isNaN(value) || value <= 0)
          error = "Voer een geldige lengte in.";
        break;
      default:
        break;
    }
    setErrors({ ...errors, [name]: error });
  };

  const onChangeRadio = (name, e) => {
    //setRadio({ ...radio, value: e });
    setFormData((prevData) => ({
      ...prevData,
      [name]: e,
    }));
  };

  const saveFormulier = useCallback(async (e) => {
    e.preventDefault();

    await savePreIntakeForm(e, userdetails,formData, admin, setOpen,errors,false,onProgressUpdate);
  },[userdetails,formData,admin,setOpen,errors,onProgressUpdate]);

  const definitiefOpslaanFormulier = useCallback(async (e) => {
    e.preventDefault();
    await savePreIntakeForm(e, userdetails,formData, admin, setOpen,errors,true,onProgressUpdate);
  },[userdetails,formData,admin,setOpen,errors,onProgressUpdate]);

  const OpmerkingPlaatsen = useCallback(async (e) => {
    e.preventDefault();
   updateOpmerking(userdetails,formData, admin, setOpen);
  },[userdetails,formData,admin,setOpen]);

  return (
    <div className="preintake-theme">
      <h2 className="mb-4 text-center text-2xl font-semibold tracking-tight text-wa-text sm:mb-6 sm:text-4xl">
        Pre-intake vragenlijst
      </h2>
      <form>
        <PersoonlijkeInfo
          editeer={editeer}
          errors={errors}
          formData={formData}
          handleChange={handleChange}
          onChangeRadio={onChangeRadio}
        />
        <HulpVraag
          editeer={editeer}
          formData={formData}
          handleChange={handleChange}
          onChangeRadio={onChangeRadio}
        />
        <Gezondheidsprofiel
          editeer={editeer}
          formData={formData}
          handleChange={handleChange}
          onChangeRadio={onChangeRadio}
        />
        {admin != null && (
          <div className="mt-8">
            <label className="mb-2 block text-sm font-medium text-wa-text/85">
              Opmerking
            </label>
            <div className="flex rounded-md bg-wa-panel ring-1 ring-inset ring-wa-border focus-within:ring-2 focus-within:ring-inset focus-within:ring-wa-accent">
              <textarea
                rows={5}
                name="opm_admin"
                value={formData.opm_admin}
                onChange={handleChange}
                className="block flex-1 border-0 bg-transparent py-1.5 pl-2 text-wa-text placeholder:text-wa-muted focus:ring-0 sm:text-sm sm:leading-6"
              />
            </div>
          </div>
        )}
      </form>
      <div className="mt-6 flex flex-col gap-2 sm:mt-5 sm:flex-row sm:justify-end">
        {admin == null ? (
          <>
            <button
              type="button"
              className="inline-flex w-full justify-center rounded-md bg-wa-accent px-3 py-2 text-sm font-semibold text-wa-onaccent shadow-sm hover:brightness-110 sm:w-auto"
              onClick={(e) => definitiefOpslaanFormulier(e)}
            >
              Opslaan en Verzenden
            </button>
            <button
              type="button"
              className="inline-flex w-full justify-center rounded-md border border-wa-border bg-wa-panel px-3 py-2 text-sm font-semibold text-wa-text shadow-sm hover:bg-wa-hover sm:w-auto"
              onClick={(e) => saveFormulier(e)}
            >
              Opslaan en later verder doen
            </button>
          </>
        ) : (
          <button
            type="button"
            className="inline-flex w-full justify-center rounded-md bg-wa-accent px-3 py-2 text-sm font-semibold text-wa-onaccent shadow-sm hover:brightness-110 sm:w-auto"
            onClick={OpmerkingPlaatsen}
          >
            Opmerking plaatsen
          </button>
        )}
        <button
          type="button"
          className="inline-flex w-full justify-center rounded-md border border-wa-border bg-wa-panel px-3 py-2 text-sm font-semibold text-wa-text shadow-sm hover:bg-wa-hover sm:w-auto"
          onClick={() => setOpen(false)}
        >
          Annuleer
        </button>
      </div>
    </div>
  );
};

export default PreIntakeForm;
